var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
	'breadcrumbs-item': true,
	'breadcrumbs-item--disabled': !_vm.breadcrumbRoute?.length
}},[(!_vm.isLast)?_c('base-link',{attrs:{"to":_vm.breadcrumbRoute,"params":_vm.breadcrumb.params}},[_c('breadcrumb-text',[_vm._v(" "+_vm._s(_vm.name)+" ")])],1):_c('breadcrumb-text',{class:{ 'breadcrumb-last': _vm.isLast }},[_vm._v(" "+_vm._s(_vm.name)+" ")]),(!_vm.isLast)?_c('base-svg',{staticClass:"icon",attrs:{"name":"breadcrumb"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }